import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyActiveTicket } from "../.././../../store/helpers";
import { updateTicket } from "../.././../../store/actions/ticketsActions";
import { modalUpdate } from "../.././../../store/actions/settingsActions";

const TrackingPackage = () => {
    const dispatch = useDispatch();
    const { tickets } = useSelector(state => state.tickets); 
    const { activeTicketId } = useSelector(state => state.tickets);
    const { hostname } = useSelector(state => state.auth);

    const ticket = getMyActiveTicket(tickets, activeTicketId);


    const [packageStatus, setPackageStatus] = useState(ticket?.tracking?.packageStatus || '');
    const [packageNotes, setPackageNotes] = useState(ticket?.tracking?.packageNotes || '');
    return (
        <div className="home-center-content1 home-center-content2">
            <div className="titleBlock">
                <h5>Package Status</h5>
            </div>

            <div className="select-options">
                <label>Package Status</label>
                <div className="selectStyling">
                    <select onChange={(e) => setPackageStatus(e.target.value)} value={packageStatus.length > 0 ? packageStatus : ticket?.tracking?.packageStatus || ''}>
                        <option value="">Select an option</option>
                        <option value="Parcel is being processed">Parcel is being processed</option>
                        <option value="Package Found">Package Found</option>
                        <option value="Package Not Found / Incorrect Number">Package Not Found / Incorrect Number</option>
                        <option value="Package Not Arrived Yet">Package Not Arrived Yet</option>
                        <option value="Package not cleared by Customs">Package not cleared by Customs.</option>
                        <option value="Package Lost">Package Lost</option>
                        <option value="Package Damaged">Package Damaged</option>
                        <option value="Package Out For Delivery">Package Out For Delivery</option>
                        <option value="Package Already Delivered">Package Already Delivered</option>
                    </select>
                </div>
            </div>
            {/* more to add */}
            <div className="input-options">
                <label>Got more to add?</label>
                <textarea placeholder="Type here" name="description" value={packageNotes} onChange={(e) => setPackageNotes(e.target.value)}></textarea>
            </div>
            <button
                type="submit"
                className={`${packageStatus.length > 0 ? "form-submit-btn" : "form-submit-btn mute"}`}
                onClick={() => {
                    if (packageStatus.length > 0) {
                        dispatch(updateTicket(hostname, { ...ticket, tracking: { ...ticket.tracking, packageStatus, packageNotes } }));
                        dispatch(modalUpdate({ visible: 0, content: null, modalType: 0 }));
                        dispatch(modalUpdate({ visible: 1, content: "TransferTicket", modalType: 1 }));
                    }
                }}
            >
                Update
            </button>
        </div>
    )
}

export default TrackingPackage;
